import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleGuide from "../pages/article/oopbuy-spreadsheet-guide/page";
import ArticleSicherheit from "../pages/article/oopbuy-spreadsheet-sicherheit/page";
import ArticleAnfaenger from "../pages/article/oopbuy-spreadsheet-anfaenger/page";
import ArticleVergleich from "../pages/article/oopbuy-spreadsheet-vergleich/page";
import ArticleTipps from "../pages/article/oopbuy-spreadsheet-tipps/page";
import ArticleKategorien from "../pages/article/oopbuy-spreadsheet-kategorien/page";
import ArticleProduktliste from "../pages/article/oopbuy-spreadsheet-produktliste/page";
import ArticleErfahrungen from "../pages/article/oopbuy-spreadsheet-erfahrungen/page";
import Einkaufsfuehrer from "../pages/einkaufsfuehrer/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-guide",
    element: <ArticleGuide />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-sicherheit",
    element: <ArticleSicherheit />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-anfaenger",
    element: <ArticleAnfaenger />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-vergleich",
    element: <ArticleVergleich />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-tipps",
    element: <ArticleTipps />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-kategorien",
    element: <ArticleKategorien />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-produktliste",
    element: <ArticleProduktliste />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-erfahrungen",
    element: <ArticleErfahrungen />,
  },
  {
    path: "/einkaufsfuehrer",
    element: <Einkaufsfuehrer />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;